// export const _BASE_URL = 'https://chengjianapi.dianliangliang.com/'; // 正式环境
export const _BASE_URL = 'https://chengjianapi.dianliangliang.com/'; // 正式环境
export const _BASE_Configuration = false; // 正式环境
// export const _BASE_URL = 'http://192.168.1.143:9960/'; // 正式环境
// export const _BASE_URL = 'http://192.168.1.141:8080/' // 测试环境
